import { DownloadFormatLabels, DownloadFormats } from '@constants/downloadFormats';
import { Option } from '@types';

export const DownloadOptions: Option<DownloadFormats>[] = [
  { label: DownloadFormatLabels.EML, value: DownloadFormats.EML },
  { label: DownloadFormatLabels.PDF, value: DownloadFormats.PDF },
  {
    label: DownloadFormatLabels.EML_PDF,
    value: DownloadFormats.EML_PDF,
  },
  {
    label: DownloadFormatLabels.ICS,
    value: DownloadFormats.ICS,
  }
];
